module.exports = __webpack_public_path__ + "static/kim-d8258cc4637cc22bcb0321960db77935.jpg";